import { useEffect, useState } from 'react';

import {
  Box,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import { TaskCloseButton } from './TaskCloseButton';
import { getUserTasks } from '../../../api/tasks';

export function MessagePopup({ user }) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);

  async function loadTasks() {
    setLoading(true);

    try {
      const result = await getUserTasks();
      setTasks(Array.isArray(result) ? result : []);
    } catch (error) {
      console.error('Feladatok betöltési hiba:', error);
      setTasks([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadTasks();
  }, []);

  return (
    <Box>
      <Typography variant='h6' fontWeight={700} sx={{ mb: 2 }}>
        Feladatok
      </Typography>

      <Stack spacing={1.5}>
        {loading && <Typography color='text.secondary'>Betöltés...</Typography>}

        {!loading && tasks.length === 0 && (
          <Typography color='text.secondary'>
            Nincs megjeleníthető feladat.
          </Typography>
        )}

        {!loading &&
          tasks.map((item) => (
            <Card
              key={item.id_task ?? `${item.TaskTitle}-${item.TaskDescr}`}
              variant='outlined'
              sx={{ borderRadius: 2 }}
            >
              <CardContent>
                <Stack
                  direction={{ xs: 'column', md: 'row' }}
                  spacing={1.5}
                  alignItems={{ xs: 'stretch', md: 'flex-start' }}
                >
                  <TextField
                    label='Feladat'
                    value={`(${item.id_task}) ${item.TaskTitle ?? ''}`}
                    size='small'
                    multiline
                    fullWidth
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                    sx={{ flex: 3 }}
                  />

                  <TextField
                    label='Leírás'
                    value={item.TaskDescr ?? ''}
                    size='small'
                    multiline
                    minRows={2}
                    fullWidth
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                    sx={{ flex: 8 }}
                  />

                  <Box
                    sx={{
                      flex: 1,
                      display: 'flex',
                      justifyContent: { xs: 'flex-start', md: 'center' },
                    }}
                  >
                    <TaskCloseButton
                      taskId={item.id_task}
                      user={user}
                      onClosed={loadTasks}
                    />
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          ))}
      </Stack>
    </Box>
  );
}
